import { keepPreviousData } from "@tanstack/react-query";
import {
  retrieveDemandSummary,
  type DemandSummaryFilters,
} from "@/lib/data/requests/reports/reports-demand-summary";
import { queryKeys } from "@/lib/data/static";

export const demandSummaryQueryOptions = (filters: DemandSummaryFilters) => ({
  queryKey: [queryKeys.reports, "demand-summary", filters],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveDemandSummary(filters, signal),
  placeholderData: keepPreviousData,
  refetchInterval: 30_000,
});
